module.exports = __webpack_public_path__ + "eight.fe3079b47234866d9cce.jpg";


//////////////////
// WEBPACK FOOTER
// C:/Users/Artem/Desktop/Programming/studio/creativeDigital/src/assets/portfolio/worksDetails/eight/eight.jpg
// module id = ../../../../../src/assets/portfolio/worksDetails/eight/eight.jpg
// module chunks = 0